module.exports = __webpack_public_path__ + "img/what-is-openapihub-thumbnail-arrow-tc.1942ddc4.jpg";